import { isMilitaryUser } from "./Helpers";

function getMissingInfoSections(user) {
  let personalComplete = true;
  let militaryComplete = true;
  let privacyComplete = true;
  if (
    !user.email ||
    !user.email_verified ||
    !user.location.address ||
    !user.first_name ||
    !user.last_name
  )
    personalComplete = false;
  const militaryUser = isMilitaryUser(user.service_info.status);
  if (militaryUser) {
    // TODO set this up better per client
    if (
      user.service_info.culturally_and_linguistically_diverse !== true ||
      user.service_info.culturally_and_linguistically_diverse !== false
    )
      militaryComplete = false;
    else if (!user.service_info.service_type) militaryComplete = false;
  }
  return {personalComplete, militaryComplete, privacyComplete};
}

export {getMissingInfoSections};
